import React, { useEffect } from 'react';
import { ModalBody } from './body';
import { ModalFooter } from './footer';
import { ModalHeader } from './header';

const Modal = ({ children, isOpen, isLarge }) => {

    useEffect(() => {
        if (isOpen) {
            document.body.classList.add('modal-open');
            document.body.style.overflow = 'hidden';
        } else {
            document.body.classList.remove('modal-open');
            document.body.style.overflow = '';
            // Clean any leftover backdrops
            document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());
        }

        return () => {
            document.body.classList.remove('modal-open');
            document.body.style.overflow = '';
        };
    }, [isOpen]);

    return (
        <>
            {/* Backdrop - only when open */}
            {isOpen && <div className="modal-backdrop fade show"></div>}

            {/* Modal */}
            <div
                className={`modal fade ${isOpen ? 'show' : ''}`}
                style={{ display: isOpen ? 'block' : 'none' }}
                tabIndex="-1"
                aria-modal={isOpen ? 'true' : undefined}
                role="dialog"
                aria-hidden={!isOpen}
            >
                <div className={`modal-dialog modal-dialog-centered ${isLarge ? 'modal2' : 'modal3'}`}>
                    <div className="modal-content">
                        {children}
                    </div>
                </div>
            </div>
        </>
    );
};

export {
    Modal, ModalBody, ModalFooter, ModalHeader
};